<template>
    <div>
        <v-row v-for="(item, index) in catalogues" :key="index">
            <SearchItem :label="item.label" :list="item.list" :selected="item.selected"></SearchItem>
        </v-row>
    </div>
</template>

<script>
    import SearchItem from "../../components/common/SearchItem"

    export default {
        props: ["catalogues"],
        components: {
            SearchItem
        },
        data() {
            return {
                
            }
        }
    }
</script>

<style scoped>
</style>